export function apiOrigin(): string {
  const config = useRuntimeConfig();
  // In mock mode, use same-origin requests so the Nitro mock-api middleware
  // handles them (no CORS, no external API dependency)
  if (config.public.mock) return '';
  if (import.meta.server) {
    return config.apiOriginServer || config.public.apiOrigin || '';
  }
  return config.public.apiOrigin || '';
}
